module.exports = __webpack_public_path__ + "static/media/starIcon.1f67749c.svg";